import { AlertTriangle } from 'lucide-react'

export default function AlarmTable({ events }) {
  if (!events || events.length === 0) {
    return (
      <div className="text-slate-500 text-center py-8">
        Son 24 saatte yüksek riskli alarm yok
      </div>
    )
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-slate-400 border-b border-slate-700">
            <th className="text-left py-2 px-3">Makine</th>
            <th className="text-left py-2 px-3">Risk</th>
            <th className="text-left py-2 px-3">Durum</th>
            <th className="text-left py-2 px-3">Zaman</th>
          </tr>
        </thead>
        <tbody>
          {events.map((e, i) => (
            <tr key={i} className="border-b border-slate-800 hover:bg-slate-800/50">
              <td className="py-2 px-3 flex items-center gap-2">
                <AlertTriangle className="w-4 h-4 text-red-400" />
                {e.name}
              </td>
              <td className="py-2 px-3">
                <span className="text-red-400 font-bold">
                  %{Math.round(parseFloat(e.ai_probability) * 100)}
                </span>
              </td>
              <td className="py-2 px-3">
                <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                  e.ai_status === 'critical' ? 'bg-red-500/20 text-red-400' :
                  e.ai_status === 'warning' ? 'bg-yellow-500/20 text-yellow-400' :
                  'bg-green-500/20 text-green-400'
                }`}>
                  {e.ai_status === 'critical' ? 'KRİTİK' :
                   e.ai_status === 'warning' ? 'UYARI' : 'NORMAL'}
                </span>
              </td>
              <td className="py-2 px-3 text-slate-400">
                {new Date(e.timestamp).toLocaleString('tr-TR')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}